import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { ExportModule } from './export.module';

import { registerSolidIconLibraries } from './app/common/iconLibrary';
import { LOG } from './app/common/util/log';
import { DemoModule } from './demo/demo.module';
import { loglevel } from './environments/environment';
import { EXTERNAL_STYLES, GLOBAL_STYLES, externalStyles } from './styles';

import '@solid-design-system/components/dist-versioned';

LOG.level = loglevel;

/**
 * styles from styles.ts is only available in builds, so for the demo the style has to be read from the referenced stylesheet.
 */
function getGlobalStyles(): string {
  const globalStyleElement: Element | null = document.head.querySelector('link[href="styles.css"]');
  const globalStyleSheet: CSSStyleSheet | undefined = [...(document.styleSheets)].find(
    sheet => sheet.ownerNode === globalStyleElement
  );
  return [...globalStyleSheet!.cssRules].map(rule => rule.cssText).join('');
}

function injectExternalStyles(): void {
  for (const externalStyle of externalStyles) {
    const style: HTMLLinkElement = document.createElement('link');
    style.rel = 'stylesheet';
    style.href = externalStyle;
    document.head.appendChild(style);
  }
}

(async function () {
  try {
    injectExternalStyles();
    registerSolidIconLibraries();
    const platform = platformBrowserDynamic([{ provide: GLOBAL_STYLES, useValue: getGlobalStyles() }, { provide: EXTERNAL_STYLES, useValue: externalStyles }]);
    await platform.bootstrapModule(ExportModule);
    await platform.bootstrapModule(DemoModule);
  } catch (err) {
    console.error(err);
  }
})();

(async function () {
  const { registerIconLibrary } = (window as any)['Solid Components'];

  registerIconLibrary('global-resources', {
    resolver: (name: any) => {
      // split path and name
      let path = name.split('/');
      let iconName = path.pop();

      // "system" and "system/colored" should both resolve to "system/colored", same for "content"
      if (path.length === 1) {
        path.push('colored');
      }

      return `https://global-resources.fe.union-investment.de/latest/scripts/services/svg/icons/${path.join(
        '/'
      )}/${iconName}.svg`;
    },

    // We need currentColor as the main color for the icons
    mutator: (svg: { querySelectorAll: (arg0: string) => any }) => {
      const recoloredElements: any = {};
      recoloredElements['currentColorFills'] = svg.querySelectorAll(
        '[fill="rgb(var(--sd-color-primary, 0 53 142))"], [fill="#fff"]'
      );
      recoloredElements['currentColorStrokes'] = svg.querySelectorAll(
        '[stroke="rgb(var(--sd-color-primary, 0 53 142))"], [stroke="#fff"]'
      );
      recoloredElements['greenFills'] = svg.querySelectorAll('[fill="#43b02a"]');
      recoloredElements['greenStrokes'] = svg.querySelectorAll('[stroke="#43b02a"]');

      recoloredElements.currentColorFills.forEach(
        (filledElement: { setAttribute: (arg0: string, arg1: string) => void }) => {
          filledElement.setAttribute('fill', 'currentColor');
        }
      );

      recoloredElements.currentColorStrokes.forEach(
        (strokedElement: { setAttribute: (arg0: string, arg1: string) => void }) => {
          strokedElement.setAttribute('stroke', 'currentColor');
        }
      );

      recoloredElements.greenFills.forEach((filledElement: { setAttribute: (arg0: string, arg1: string) => void }) => {
        filledElement.setAttribute('fill', 'rgb(var(--sd-color-accent, 67 176 42) / var(--tw-bg-opacity, 1))');
      });

      recoloredElements.greenStrokes.forEach(
        (strokedElement: { setAttribute: (arg0: string, arg1: string) => void }) => {
          strokedElement.setAttribute('stroke', 'rgb(var(--sd-color-accent, 67 176 42) / var(--tw-bg-opacity, 1))');
        }
      );
      return svg;
    },
  });

  console.log('icons loaded');
})();
